import { useEffect, useRef, useState } from 'react';
import { Buffer } from 'buffer';

import { isProductionEnv } from '~/core/shared/utils/environment';
import loadSmartCommDraftEditorApi from './lib/loadSmartcommApi';

interface SmartCommEditorProps {
  draftData: string;
}

export const SmartCommEditor = ({ draftData }: SmartCommEditorProps) => {
  const [editor, setEditor] = useState<any>();
  const [ready, setReady] = useState<boolean>(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const baseUrl = isProductionEnv()
    ? 'https://ap11.smartcommunications.cloud'
    : 'https://ap10-sb.smartcommunications.cloud';

  useEffect(
    () =>
      loadSmartCommDraftEditorApi(baseUrl, () => {
        setReady(true);
      }),
    [],
  );

  const renderDraftEditor = () => {
    if (editor) {
      editor.destroy();
      setEditor(undefined);
    }

    /** @ts-expect-error Cannot find name 'Thunderhead'.ts(2304) */
    Thunderhead.DraftEditor.create({
      server: baseUrl,
      clientServer: window.location.origin,
      authParams: `targetURL=${baseUrl}/one/draft-editor/draft-editor.jsp?clientServer=${encodeURI(window.location.origin)}`,
      targetElementID: 'application',
      loadStartupConfig: () => ({
        version: '2',
        editingMode: 'defaultMode',
      }),
    }).then(setEditor);
  };

  const loadDraftData = () => {
    if (draftData) {
      editor.v3
        .loadString(Buffer.from(draftData, 'base64').toString(), {
          openInPreview: true,
        })
        .catch(() => {
          alert('Failed to load draft editor.');
        });
    }
  };

  function getDraftAsString() {
    editor.v3
      .saveToString()
      .then((result: any) => {
        // result.draftXML;
      })
      .catch(() => {
        alert('API call failed');
      });
  }

  // Render the draft editor from SmartComm when the DOM finishes loading
  useEffect(() => {
    if (ready && iframeRef.current) {
      renderDraftEditor();
    }
  }, [iframeRef.current, ready]);

  // Load the draft data into the editor when either changes
  useEffect(() => {
    if (editor) {
      loadDraftData();
    }
  }, [draftData, editor]);

  return (
    <div id="application">
      <iframe
        ref={iframeRef}
        height="100%"
        id="draftEditorWindow"
        name="draftEditorWindow"
        src={`${baseUrl}/one/draft-editor/draft-editor.html?clientServer=https%3A%2F%2Fap10-sb.smartcommunications.cloud`}
        style={{ minHeight: '1000px' }}
        title="Smart Communications Draft Editor"
        width="100%"
      />
    </div>
  );
};
